export default function Fallback() {
  return (
    <p>
      일시적인 문제가 있습니다.
      <br/>
      해당 페이지를 새로고침하거나
      <br/>
      관리자에게 문의하여주십시오.
    </p>
  )
}
